export const PREVIEW_DOMAIN = 'preview.test.kijk.nl';
